  <template>
    <div class="login-page">
      <!-- 背景图 -->
      <img src="../assets/img/loginimg.png" class="bg-img" alt="background">

      <!-- 左上角标题 -->
      <div class="header-title">能碳管理平台</div>

      <div class="main-content">
        <!-- 右侧登录卡片 -->
        <el-card class="login-card" shadow="always">
          <div slot="header" class="card-header">
            <span class="title">登录系统</span>
          </div>

          <div class="welcome-text">欢迎进入能碳管理平台</div>

          <el-form :rules="rules" ref="loginForm" :model="loginForm" class="login-form" @keydown.enter.native="handleEnterKey">
            <el-form-item prop="username">
              <el-input
                v-model="loginForm.username"
                placeholder="请输入用户名"
                prefix-icon="el-icon-user"
                class="custom-input">
              </el-input>
            </el-form-item>

            <el-form-item prop="password">
              <el-input
                show-password
                v-model="loginForm.password"
                placeholder="请输入密码"
                prefix-icon="el-icon-lock"
                class="custom-input">
              </el-input>
            </el-form-item>

            <div class="form-footer">
              <el-checkbox v-model="rememberMe">记住密码</el-checkbox>
              <el-link type="primary" :underline="false" class="forgot-password-link">找回密码</el-link>
            </div>

            <div class="form-actions">
              <el-button class="submit-button" type="primary" @click="Login">
                登 录
              </el-button>
            </div>
          </el-form>
        </el-card>
      </div>
    </div>
  </template>

  <script>
  import axios from "axios";

  export default {
    data() {
      return {
        rememberMe: false,
        loginForm: {
          username: '',
          password: '',
        },
        rules: {
          username: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 2, max: 20, message: '密码长度在2到20位之间', trigger: 'blur' }
          ]
        }
      };
    },
    methods: {
      Login() {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 2000);
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            axios.post('/otherApi/login/', this.loginForm)
              .then(res => {
              if (res.data.code === 200) {
                localStorage.setItem('user', JSON.stringify(res.data.data));
                const userRole = res.data.data.is_staff;
                const username = res.data.data.user_name;
                if (userRole === "0") {
                  this.$router.push('/root');
                } else if (username === "华兰基因"){
                  if (this.$route.path !== '/HLSWLyzYm') {
                    this.$router.push({path:'/HLSWLyzYm',query:res.data.data});
                  }
                } else if (userRole === "1") {
                  if (this.$route.path !== '/menu/userNewHome') {
                    this.$router.push({path:'/menu/userNewHome',query:res.data.data});
                  }
                } else {
                  this.$router.push('/test')
                }
                this.$message.success('登录成功!');
              } else {
                this.$message.error(res.data.msg || "用户名或密码错误");
              }
            }).catch(error => {
              console.error("请求失败:", error);
              this.$message.error('登录请求失败')
            });
          } else {
            return false;
          }
        });
      },
      handleEnterKey(event) {
        if (event.keyCode === 13) {
          this.Login();
        }
      }
    },
  };
  </script>

  <style scoped>
  .login-page {
    height: 100vh;
    width: 100vw;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    color: white;
    font-family: "Microsoft YaHei", sans-serif;
  }

  .bg-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: fill; /* 确保图片完全填充且不被裁剪，达到用户要求的“饱和”感 */
    z-index: 0;
  }

  .header-title {
    position: absolute;
    top: 60px;
    left: 140px;
    font-size: 64px;
    font-weight: bold;
    letter-spacing: 4px;
    z-index: 2;
    color: #ffffff;
    text-shadow: 0 4px 15px rgba(0,0,0,0.6);
  }

  .main-content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 8%;
    z-index: 1;
  }

  .login-card {
    width: 460px;
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4) !important;
    border: none;
    margin-top: 40px;
  }

  .login-card /deep/ .el-card__header {
    padding: 0;
    border-bottom: 1px solid #f0f0f0;
  }

  .card-header {
    padding: 22px 0;
    text-align: center;
    position: relative;
  }

  .card-header .title {
    font-size: 24px;
    font-weight: bold;
    color: #4080ff;
  }

  .card-header::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 25%;
    width: 50%;
    height: 4px;
    background: #4080ff;
    border-radius: 2px;
  }

  .welcome-text {
    text-align: center;
    margin: 30px 0 25px;
    color: #909399;
    font-size: 18px;
  }

  .login-form {
    padding: 0 20px 20px;
  }

  .custom-input /deep/ .el-input__inner {
    height: 50px;
    border-radius: 8px;
    font-size: 16px;
    background-color: #f5f7fa;
    border: 1px solid #e4e7ed;
    transition: all 0.3s;
  }

  .custom-input /deep/ .el-input__inner:focus {
    background-color: #fff;
    border-color: #4080ff;
  }

  .custom-input /deep/ .el-input__prefix {
    font-size: 20px;
    color: #4080ff;
    display: flex;
    align-items: center;
  }

  .form-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
  }

  .forgot-password-link {
    font-size: 14px;
  }

  .submit-button {
    width: 100%;
    height: 50px;
    border-radius: 25px;
    font-size: 20px;
    background: linear-gradient(135deg, #4a86e8 0%, #4080ff 100%);
    border: none;
    letter-spacing: 10px;
    text-indent: 10px;
    box-shadow: 0 6px 20px rgba(74, 134, 232, 0.3);
    transition: all 0.3s;
  }

  .submit-button:hover {
    background: #3b71c9;
    transform: translateY(-2px);
  }

  @media (max-width: 1600px) {
    .header-title { font-size: 52px; left: 240px; }
    .login-card { width: 420px; }
  }
  </style>




// WEBPACK FOOTER //
// src/views/Login.vue